import { render, staticRenderFns } from "./WordBook.vue?vue&type=template&id=665a350a&scoped=true"
import script from "./WordBook.vue?vue&type=script&lang=js"
export * from "./WordBook.vue?vue&type=script&lang=js"
import style0 from "./WordBook.vue?vue&type=style&index=0&id=665a350a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665a350a",
  null
  
)

export default component.exports